import * as types from '../mutation-types';

const state = {
  // Bumped on every reset (view-context switch). Section fetches capture it
  // before their request and drop the response if it changed mid-flight, so a
  // slow fetch from the previous context (e.g. MakerHub) can't commit its rows
  // into the next one (e.g. Smith3D).
  fetchEpoch: 0,
  currentPage: {
    me: 0,
    unassigned: 0,
    urgent: 0,
    pending: 0,
    group: 0,
    all: 0,
    all_unreplied: 0,
    all_replied: 0,
    appliedFilters: 0,
  },
  nextCursor: {
    me: null,
    unassigned: null,
    urgent: null,
    pending: null,
    group: null,
    all: null,
    all_unreplied: null,
    all_replied: null,
    appliedFilters: null,
  },
  hasEndReached: {
    me: false,
    unassigned: false,
    urgent: false,
    pending: false,
    group: false,
    all: false,
    all_unreplied: false,
    all_replied: false,
    appliedFilters: false,
  },
};

export const getters = {
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter];
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter];
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
  getNextCursor: $state => filter => $state.nextCursor[filter],
  getFetchEpoch: $state => $state.fetchEpoch,
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  setNextCursor({ commit }, { filter, cursor }) {
    commit(types.default.SET_CONVERSATION_CURSOR, { filter, cursor });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    if (filter === 'all') {
      $state.hasEndReached = {
        ...$state.hasEndReached,
        unassigned: true,
        me: true,
        urgent: true,
        pending: true,
      };
    }
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.SET_CONVERSATION_CURSOR]: ($state, { filter, cursor }) => {
    $state.nextCursor = { ...$state.nextCursor, [filter]: cursor || null };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.fetchEpoch += 1;
    $state.currentPage = {
      me: 0,
      unassigned: 0,
      urgent: 0,
      pending: 0,
      group: 0,
      all: 0,
      all_unreplied: 0,
      all_replied: 0,
      appliedFilters: 0,
    };

    $state.nextCursor = {
      me: null,
      unassigned: null,
      urgent: null,
      pending: null,
      group: null,
      all: null,
      all_unreplied: null,
      all_replied: null,
      appliedFilters: null,
    };

    $state.hasEndReached = {
      me: false,
      unassigned: false,
      urgent: false,
      pending: false,
      group: false,
      all: false,
      all_unreplied: false,
      all_replied: false,
      appliedFilters: false,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
